<template>
  <v-progress-circular
    :model-value="$attrs.value ? $attrs.width : 75"
    :color="$attrs.color || ($projectName === $projectNames.MOSAP ? 'var(--pageContrastFont)' : 'var(--pageAccentBackground)')"
    :size="$attrs.size ? $attrs.size : 70"
    :width="$attrs.width ? $attrs.width : 7"
    v-bind="$attrs"
    class="base-loader"
    :class="classes"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BaseComponent from '../BaseComponent/BaseComponent.vue';

export default defineComponent({
  name: 'BaseLoader',
  extends: BaseComponent,
});
</script>

<style lang="scss" scoped>
.base-loader {
  &.variant {
    &__page {
      animation: spin 1.1s infinite linear;
    }
  }
}

@if mixin-exists("ThemeBaseLoader") {
  @include ThemeBaseLoader;
}
</style>
